import { render, staticRenderFns } from "./ContactsDataAdministrationCampaigns.vue?vue&type=template&id=4a77996a&scoped=true"
import script from "./ContactsDataAdministrationCampaigns.vue?vue&type=script&lang=js"
export * from "./ContactsDataAdministrationCampaigns.vue?vue&type=script&lang=js"
import style0 from "./ContactsDataAdministrationCampaigns.vue?vue&type=style&index=0&id=4a77996a&prod&scoped=true&lang=css"
import style1 from "./ContactsDataAdministrationCampaigns.vue?vue&type=style&index=1&id=4a77996a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a77996a",
  null
  
)

export default component.exports